module.exports = __webpack_public_path__ + "/img/SOJ-7Iudwt.svg";